import React from "react";
import { Box, Typography } from "@mui/material";

interface TableAvatarProps {
  name: string;
  size?: number;
  bgcolor?: string;
  fontSize?: number;
  showLabel?: boolean;
}

const TableAvatar: React.FC<TableAvatarProps> = ({
  name,
  size = 25,
  bgcolor = "rgba(246, 51, 63, 1)",
  fontSize = 14,
  showLabel = true,
}) => {
  if (!name) return null;

  return (
    <Box display="flex" alignItems="center">
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor,
          color: "white",
          marginRight: 2,
          fontSize: fontSize - 2,
          fontWeight: 500,
        }}
      >
        {name.charAt(0).toUpperCase()}
      </Box>
      {showLabel && (
        <Typography sx={{ fontSize, fontWeight: 500 }}>{name}</Typography>
      )}
    </Box>
  );
};

export default TableAvatar;
